import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=266344f1"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266344f1')) {
      api.createRecord('266344f1', component.options)
    } else {
      api.reload('266344f1', component.options)
    }
    module.hot.accept("./Record.vue?vue&type=template&id=266344f1", function () {
      api.rerender('266344f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/Record.vue"
export default component.exports